<section class="order-chooser" aria-labelledby="order-chooser-title">
    <div class="order-chooser-handle" aria-hidden="true"></div>
    <button type="button" class="order-chooser-close" aria-label="Fermer la fenêtre de commande" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>

    <div class="order-chooser-heading">
        <span class="order-chooser-eyebrow">Resto Pita Shawarma</span>
        <h2 id="order-chooser-title">Commandez en ligne</h2>
        <p>Choisissez votre application préférée</p>
    </div>

    <div class="order-platforms">
        <a *ngFor="let platform of platforms"
           class="order-platform"
           [href]="platform.url"
           target="_blank"
           rel="noopener noreferrer"
           [attr.aria-label]="'Commander avec ' + platform.name + ' (ouvre dans un nouvel onglet)'"
           (click)="selectPlatform()">
            <span class="order-platform-logo">
                <img [src]="platform.logo" [alt]="platform.name">
            </span>
            <span class="order-platform-name">{{platform.name}}</span>
            <span class="order-platform-action">Commander <i class="fas fa-arrow-right" aria-hidden="true"></i></span>
        </a>
    </div>
</section>
